import React from 'react'
import { checkTextTranslation, getObject, priceStandardView } from '../../utils/useful'

class TablePriceInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {

        let styleInfo = this.props.styleInfo
        let info = this.props.header?.information

        let leftIndicator = info?.leftIndicator
        let rightIndicator = info?.rightIndicator
        let unit

        if (info?.unit) {
            unit = getObject(this.props.fullData, info.unit?.key)
            if (unit == null && info?.unit?.information?.default) {
                unit = info?.unit?.information?.default
            }

            if (unit && Array.isArray(info?.unit?.information?.items)) {
                let items = info?.unit?.information?.items
                for (let index = 0; index < items.length; index++) {
                    const item = items[index];
                    if (item.value == unit) {
                        unit = item.title
                    }
                }
            }
        }


        if (unit == '{{currency}}') {
            unit = this.props.variables?.currency ?? '$'
        }

        if (leftIndicator == '{{currency}}') {
            leftIndicator = this.props.variables?.currency ?? '$'
        }

        if (rightIndicator == '{{currency}}') {
            rightIndicator = this.props.variables?.currency ?? '$'
        }

        let finalPrice = this.props.data
        let basePrice


        if (typeof finalPrice == 'object') {
            finalPrice = finalPrice?.final
            if (finalPrice != this.props.data?.base) {
                basePrice = this.props.data?.base
            }
        }


        return (
            <div className="w-100 h-100 flexcc">

                <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }}>

                    {this.props.data && leftIndicator && (
                        <span>{leftIndicator}</span>
                    )}

                    {this.props.data && unit && (
                        <span>{unit}</span>
                    )}

                    <span>
                        {basePrice && (
                            <span className='text-smallest mrd-1 text-lined'>{basePrice}</span>
                        )}

                        {(this.props.data != null && finalPrice != null) ? priceStandardView(String(finalPrice)) : ' '}</span>

                    {this.props.data && rightIndicator && (
                        <span className="pld-1 pld-1 ">{rightIndicator}</span>
                    )}
                </p>




            </div>
        )
    }
}

export default TablePriceInput;